import { useQuery } from '@apollo/client';
import { GetBasicTaxiPricingsResponse, GetBasicTaxiPricingsRequest, CITRIN_GET_BASIC_TAXI_PRICINGS } from '..';

export const useGetBasicTaxiPricingsQuery = () => {
    const { data, previousData, ...rest } = useQuery<GetBasicTaxiPricingsResponse, GetBasicTaxiPricingsRequest>(
        CITRIN_GET_BASIC_TAXI_PRICINGS,
        {
            fetchPolicy: 'network-only',
            // onCompleted: (data) => console.log('[MGT] Pricing', data),
        }
    );

    return {
        ...rest,
        previousData: previousData?.CITRIN_MGT_getBasicTaxiPricings,
        data: data?.CITRIN_MGT_getBasicTaxiPricings ?? [],
    };
};
